import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LeadJournalEntry  {
    _originalTypeClassName = "zPMO.BO.LeadJournalEntry";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LeadJournalEntry.translate = translateService;
}
this.Id = null;
this.Date = null;
this.OldValue = null;
this.NewValue = null;
this.OldId = null;
this.NewId = null;
this.Type = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Date:any;
OldValue:any;
NewValue:any;
OldId:any;
NewId:any;
Type:any;
Lead:any;
PMOUser:any;
static setLead = ($this, value) => {
var oldValue = $this.Lead;
$this.Lead = value;
if (value != null) {
if (oldValue != null) {
Domain.Lead.removeJournalEntries(oldValue, $this);
}
Domain.Lead.addJournalEntries(value, $this);
}
}
static setPMOUser = ($this, value) => {
var oldValue = $this.PMOUser;
$this.PMOUser = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}